import { editorConfig } from '~config';
import { getState, getStatePure, modifyState } from '~src/state';
import { highlightCurrentPage } from '~src/multipages';
import {
  ensureCurrentPageImage,
  markCurrentPageImageDirty,
} from './currentPageImage';
import { flushCurrentPageThumbnail } from './generateCurrentPageThumbnail';
import { resolveLogosOnCurrentPage } from '~src/sidebar/logo';
import { setProfilePhotoToAllMagicFrames } from '~src/utils';
import { replaceImageUrlsWithImage } from '~core';
import { convertTextboxesToSpellCheck } from '~core/spellcheck';

export const goToPage = (pageIndex) => {
  return new Promise((resolve) => {
    if (!getState('isChangingPage')) {
      const oldPageIndex = getState('currentPageIndex');

      // Dopo il cambio il canvas mostra un'altra pagina: miniatura e immagine
      // di stampa di quella che si lascia vanno aggiornate adesso.
      if (pageIndex !== oldPageIndex) {
        flushCurrentPageThumbnail();
        try {
          ensureCurrentPageImage();
        } catch (error) {
          // imgDataDirty resta true: le esportazioni useranno canvasJson.
          console.warn('Cannot generate page image before leaving it', error);
        }
      }

      modifyState('isChangingPage', true);
      const currentPageJson = JSON.stringify(
        window.canvas.toJSON(editorConfig.additionalJsonProperties)
      );
      modifyState('currentPageIndex', pageIndex);
      // Il canvas sta per ricaricare la pagina: imgData va rigenerata anche se
      // nessun after:render arrivasse al dispatcher.
      markCurrentPageImageDirty();
      modifyState(`pages[${oldPageIndex}].canvasJson`, currentPageJson).then(
        () => {
          const pages = getStatePure('pages');

          // Check if pageIndex is valid
          if (!pages[pageIndex]) {
            console.error(
              `Invalid page index: ${pageIndex}. Total pages: ${pages.length}`
            );
            modifyState('isChangingPage', false);
            resolve();
            return;
          }

          const { canvasJson } = pages[pageIndex];

          window.canvas.loadFromJSON(canvasJson, async () => {
            await convertTextboxesToSpellCheck(window.canvas);

            await resolveLogosOnCurrentPage();
            modifyState('undoInProgress', false);
            await setProfilePhotoToAllMagicFrames();
            await replaceImageUrlsWithImage();
            window.canvas.renderAll();
            highlightCurrentPage();
            modifyState('isChangingPage', false);
            resolve();
          });
        }
      );
    }
  });
};
